import { getSettingsInstance } from "./Settings";
//import { formatDateTime } from "../../api/date";
import * as dev from '../../api/dev'

/**
 * record structure:
 */
const fields = [
    "ID",
    "Tool",
    "Name",
    "Color",
    "SelectedUsers",
    "SelectedUserIds",
    "SpeedFrom",
    "SpeedTo",
    "Shapes",
    "ShowOnMap",
    "ON",
    "AddToDynGroup",
    "DeleteFromDynGroup",
    "DynGroup",
    "DynGroupId",
    "EntryActions",
    "LeaveActions",
    "SpeedActions"
]


export class GeofencesStorage{

    constructor(indexedDB, onConnect){

        this.db = null;

        this.indexedDB = indexedDB

        this.indexedDB.addUpgradeListener(this.onUpgradeNeeded.bind(this))
        this.indexedDB.addConnectListener(this.onConnect.bind(this))

        this.deleteListeners = []

        this.handleConnect = onConnect

    }

    addDeleteListener(callback){
        this.deleteListeners.push(callback)
    }

    onConnect(db){

        this.db = db
       
        if(this.handleConnect) this.handleConnect()

        //clean now
        //this.cleanUp()
        //and every 3 hours
        //this.cleanUpTimer = setInterval(this.cleanUp.bind(this), 1000*60*60*3)
    }


    onUpgradeNeeded(event){

        //alert('Geofences onUpgradeNeeded')
        console.log('db Geofences upgrade needed')

        let transaction = event.target.transaction;
        this.db = event.target.result;

        let geofencesStore
        if (!this.db.objectStoreNames.contains('Geofences')) {
            console.log('create Geofences store')
            geofencesStore = this.db.createObjectStore("Geofences", { keyPath : "ID" });
        }else{
            console.log('exist store Geofences')
        }

        if(!geofencesStore){
            geofencesStore = transaction.objectStore('Geofences');
        } 

        

        //let dateIndex
        /*
        try {
            //dateIndex = 
            eventsLogStore.index("date_idx");
            console.log('exist index EventsLog.date_idx')
        } catch (error) {
            if(error.name==='NotFoundError'){
                console.log('create EventsLog.date_idx')
                //dateIndex = 
                eventsLogStore.createIndex('date_idx', 'datetime');
            }
        }*/
    
    };

    connected(){
        return Boolean(this.db)
    }

    /**
     * add geofence to log
     */
    add(geofence){

        if(!this.connected()) return

        //console.log('Add geofence')
        //console.log({...geofence})
        if(!this.check(geofence)) return   

        const transaction = this.db.transaction(["Geofences"],"readwrite");
        transaction.oncomplete = function(event) {
            //console.log("Success");
        };

        transaction.onerror = function(event) {
            //console.log("Error");
        };  
        const geofences = transaction.objectStore("Geofences");
        geofences.add(geofence);
    }

    check(geofence){
        //check for required fields
        //console.log('Geofences check')
        //console.log(geofence)
        //console.log(Object.keys(geofence))
        Object.keys(geofence).forEach(item => {
            //console.log('item ' + item)
            if(fields.indexOf(item)===-1){
                alert("Geofences: unexpected field "+item)
                return false
            }
        });

        return true
    }

    update(ID, updatedFields){
        console.log('updateEvent')
        const transaction = this.db.transaction(["Geofences"], "readwrite")
        const geofencesStore = transaction.objectStore("Geofences")
        //const index = geofencesStore.index("ID")

        if(ID){
            console.log('geofencesStore')
            console.log(geofencesStore)
            console.log('ID')
            console.log(ID)
            console.log('updatedFields')
            console.log(updatedFields)
            const request = geofencesStore.get(ID)
            request.onsuccess = function() {
                if (request.result !== undefined) {
                    console.log('request.result')
                    console.log(request.result)
                    let geofence = {...request.result, ...updatedFields}

                    transaction.oncomplete = function(event) {
                        console.log("Success")
                    }
            
                    transaction.onerror = function(event) {
                        console.log("Error")
                    }
                    //const log = transaction.objectStore("EventsLog");

                    console.log('put')
                    console.log(geofence)

                    geofencesStore.put(geofence)

                }
            }
        }

    }

    delete(ID){
        const transaction = this.db.transaction(["Geofences"], "readwrite")
        const geofencesStore = transaction.objectStore("Geofences")
        geofencesStore.delete(ID)
    }


    query(filter, onsuccess, onerror){
        //select events from db
        if(!this.connected()) return

        //console.log('geofence query')
        const transaction = this.db.transaction(["Geofences"], "readonly");
        const geofencesStore = transaction.objectStore("Geofences");
        let cursor
        //let useFilter = true
        let useSort = true

        //console.log('geofence query')
        //console.log(filter)

        //let request
        //let range

        //console.log('use ID (default)')
        //console.log(geofencesStore)

        //const geofencesIndex = geofencesStore.index("ID");
        //range = null
        //cursor = geofencesIndex.openCursor(range, 'prev')


        cursor = geofencesStore.openCursor()

        useSort = false
        

        let result = []
        let count = 0
        cursor.onsuccess = event => {
            let cursor = event.target.result;
            if(cursor){
                //console.log('geofencesStore cursor')
                //console.log(cursor)
                //console.log('geofencesStore cursor.value')
                //console.log(cursor.value)
                //if(!useFilter){
                    result.push(cursor.value)
                //}
                count ++
                cursor.continue();
            }else{
                onsuccess(result)
            }
        }
       
        cursor.onerror = event => {
            onerror(event)
        }

        /*
        request.onsuccess = ()=>{
            alert('success')
            onsuccess(request.result)
        }
        request.onerror = ()=>{
            alert('error')
            onerror()
        }
        */

    }

/*
    cleanUp(){

        const settings = getSettingsInstance()

        const clearDataDays = settings.get('clearDataDays')
        
        if(clearDataDays>0){

            const date = new Date()
            date.setDate(date.getDate() - clearDataDays)

            //alert(formatDateTime(date.getTime(), 'full_date'))
            console.log('events log cleanup before ' + formatDateTime(date.getTime()))

            const transaction = this.db.transaction(["EventsLog"], "readwrite");
            const eventsLogStore = transaction.objectStore("EventsLog");
            const range = IDBKeyRange.upperBound(date.getTime()) 

            const dateIndex = eventsLogStore.index("date_idx");
            const cursor = dateIndex.openCursor(range)

            cursor.onsuccess = event => {
                let cursor = event.target.result;
                if(cursor) {

                    this.deleteListeners.forEach(callback => {
                        callback(cursor.value)
                    })

                    //console.log('cursor.value')
                    //console.log(cursor.value)
                    eventsLogStore.delete(cursor.value.id)
                    //console.log('delete event ' + cursor.value.id)
                    cursor.continue();
                }else{
                    console.log('cleanup complete')
                }
            }

        }

    }
    */

}

